<form [formGroup]="crudForm">
  <div mat-dialog-content class="dialog-content">
    <h1 mat-dialog-title>{{mode}} </h1>
    <mat-form-field appearance="fill" style=" margin: 0.6rem 0.6rem 0 0;">
      <mat-label>Coordinate</mat-label>
      <mat-select name="selectedCoordinate" formControlName="selectedCoordinate" [disabled]="crudForm.invalid" >
        <mat-option [value]="0">Decimal Degrees</mat-option>
        <mat-option [value]="1">Degree/Minutes</mat-option>
        <mat-option [value]="2">Degree/Minutes/Seconds</mat-option>
      </mat-select>
    </mat-form-field>

    <section class="dialog-form-group" *ngIf="crudForm.controls.selectedCoordinate.value == 0">
      <mat-form-field appearance="outline">
        <mat-label>Latitude</mat-label>
        <input matInput type="number" name="latitudeDD" formControlName="latitudeDD">
        <mat-error *ngIf="crudForm.controls.latitudeDD.hasError('range')">
          Latitude must lie between -90 to 90
        </mat-error>
        <mat-error *ngIf="crudForm.controls.latitudeDD.hasError('required')">
          Latitude field is <strong> required!</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Longitude</mat-label>
        <input matInput type="number" name="longitudeDD" formControlName="longitudeDD">
        <mat-error *ngIf="crudForm.controls.longitudeDD.hasError('range')">
          Longitude must lie between -180 to 180
        </mat-error>
        <mat-error *ngIf="crudForm.controls.longitudeDD.hasError('required')">
          Longitude field is <strong> required!</strong>
        </mat-error>
      </mat-form-field>
    </section>

    <section class="latlang-control-group" *ngIf="crudForm.controls.selectedCoordinate.value == 2">
      <mat-form-field class="first-control" appearance="outline">
        <mat-label>Latitude</mat-label>
        <app-latlong-input 
            formControlName = "latitudeDMS"
            [coordinateType]="'DMS'"
            ></app-latlong-input>
            <mat-error *ngIf="crudForm.controls.latitudeDMS.hasError('range') && !crudForm.controls.latitudeDMS.hasError('required')">
              Latitude must lie between -90 to 90
            </mat-error>
            <mat-error *ngIf="crudForm.controls.latitudeDMS.hasError('required')">
              One or more values are empty!
            </mat-error>
      </mat-form-field>
      <mat-form-field class="second-control" appearance="outline">
        <select matNativeControl name="latDirection" formControlName="latDirection">
          <option value="N">N</option>
          <option value="S">S</option>
        </select>
      </mat-form-field>
    </section>

    <section class="latlang-control-group" *ngIf="crudForm.controls.selectedCoordinate.value == 2">
      <mat-form-field class="first-control" appearance="outline">
        <mat-label>Longitude</mat-label>
        <app-latlong-input 
            formControlName = "longitudeDMS"
            [coordinateType]="'DMS'"
            ></app-latlong-input>
            <mat-error *ngIf="crudForm.controls.longitudeDMS.hasError('range') && !crudForm.controls.longitudeDMS.hasError('required')">
              Longitude must lie between -180 to 180
            </mat-error>
            <mat-error *ngIf="crudForm.controls.longitudeDMS.hasError('required')">
              One or more values are empty!
            </mat-error>
      </mat-form-field>
      <mat-form-field class="second-control" appearance="outline">
        <select matNativeControl name="longDirection" formControlName="longDirection">
          <option value="E">E</option>
          <option value="W">W</option>
        </select>
      </mat-form-field>
    </section>

    <section class="latlang-control-group" *ngIf="crudForm.controls.selectedCoordinate.value == 1">
      <mat-form-field class="first-control" appearance="outline">
        <mat-label>Latitude</mat-label>
        <app-latlong-input 
            formControlName = "latitudeDM"
            [coordinateType]="'DM'"
            ></app-latlong-input>
            <mat-error *ngIf="crudForm.controls.latitudeDM.hasError('range')">
              Latitude must lie between -90 to 90
            </mat-error>
            <mat-error *ngIf="crudForm.controls.latitudeDM.hasError('required')">
              One or more values are empty!
            </mat-error>
      </mat-form-field>
      <mat-form-field class="second-control" appearance="outline">
        <select matNativeControl name="latDirection" formControlName="latDirection">
          <option value="N">N</option>
          <option value="S">S</option>
        </select>
      </mat-form-field>
    </section>

    <section class="latlang-control-group" *ngIf="crudForm.controls.selectedCoordinate.value == 1">
      <mat-form-field class="first-control" appearance="outline">
        <mat-label>Longitude</mat-label>
        <app-latlong-input 
            formControlName = "longitudeDM"
            [coordinateType]="'DM'"
            ></app-latlong-input>
            <mat-error *ngIf="crudForm.controls.longitudeDM.hasError('range')">
              Longitude must lie between -180 to 180
            </mat-error>
            <mat-error *ngIf="crudForm.controls.longitudeDM.hasError('required')">
              One or more values are empty!
            </mat-error>
      </mat-form-field>
      <mat-form-field class="second-control" appearance="outline">
        <select matNativeControl name="longDirection" formControlName="longDirection">
          <option value="E">E</option>
          <option value="W">W</option>
        </select>
      </mat-form-field>
    </section>

    <mat-form-field appearance="outline">
      <mat-label>Elevation</mat-label>
      <input matInput type="text" maxlength="15" name="elevation" formControlName="elevation">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput type="text" maxlength="15" name="itineraryName" formControlName="itineraryName">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Comments</mat-label>
      <textarea matInput type="text" maxlength="100" name="comment" formControlName="comment"></textarea>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button (click)="cancel()">Cancel</button>
    <button mat-raised-button
            color="primary"
            type="submit"
            [disabled]="crudForm.invalid && !crudForm.touched"
            (click)="onSubmit()">
            Ok
    </button>
  </div>
</form>